<template>
	<div>
		<app-header></app-header>
		
		<div class="mt-3">
			<div class="row">
				<div class="col-sm-4"></div>
				<div class="col-sm-4">
					<fieldset v-loading="loading">
						<!-- TODO: Add error handling -->
						<legend>Register</legend>
						
						<div class="form-group">
	                        <img :src="photoURL">
	                    </div>
						
						<div class="form-group">
						    <label>Photo</label>
						    <input type="file" class="form-control" @change="onFileSelected">
						</div>

						<div class="form-group">
						    <label>Username</label>
						    <input type="text" class="form-control" v-model="username">
						</div>

						<button class="btn btn-success" @click="updateProfile">Change</button>

					</fieldset>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import firebase from 'firebase';

export default {
	data() {
		return {
			username : '',
			photoURL : '',
			selectedFile: null,
			user: {},
			loading: false
		}
	},
	methods: {
		onFileSelected(event) {
			this.selectedFile = event.target.files[0];
		},
		updateProfile() {
			this.loading = true;

			var storageRef = firebase.storage().ref()
			var metadata = { contentType : this.selectedFile.type }
			var name = (+new Date()) + '-' + this.selectedFile.name;

			storageRef.child(name).put(this.selectedFile,metadata)
			.then(snapshot => {
				var urlPromise = storageRef.child(name).getDownloadURL();

				urlPromise.then(url => {
					this.user.updateProfile({
						photoURL : url
					})
					this.photoURL = url;
					this.loading = false;
				})
			})
			.catch((err) => {
				console.log("* Error")
				console.log(err)
				this.loading = false;
			})
		}
	},
	beforeMount() {
		this.user = firebase.auth().currentUser;
		this.username = this.user.displayName;
		this.photoURL = this.user.photoURL ? this.user.photoURL : 'http://placehold.it/580x500';
		console.log(this.user)
	}
}
</script>

<style type="text/css" scoped>
	img {
		width : 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/user/UserEdit.vue